module.exports = new __parcel__URL__("sedac-popdensity-yeargrid5yr-v4.11.thumbnails.population.density.5404e1c1.png").toString();